module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharisma@2x.ccfbad3.webp";